( function () {
	'use strict';

	function deleteschedservice ( $modal ) {
		function openModal ( event ) {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/schedules/delete-schedule/delete-schedule-modal.html',
				'controller'   : 'DeleteScheduleModal',
				'controllerAs' : 'vm',
				'resolve'      : {
					'eventModel' : function () {
						return event;
					}
				}
			} );

			return modalInstance.result;
		}

		function deleteObsModal ( obsId ) {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/observations/observations-list/obs-delete-modal.html',
				'controller'   : 'ObsDeleteModalController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'observationId' : function () {
						return obsId;
					}
				}
			} );

			return modalInstance.result;
		}

		return {
			'openModal'      : openModal,
			'deleteObsModal' : deleteObsModal
		};
	}

	angular
		.module( 'app.schedules' )
		.factory( 'deleteschedservice', deleteschedservice );

	deleteschedservice.$inject = [ '$modal' ];
} )( );
